import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOrganisation } from '../hooks/useOrganisation';

export function RouteToHome() {
	const organisation = useOrganisation();
	const navigation = useNavigate();

	useEffect(() => {
		if (organisation.get()) {
			navigation(`/${organisation.get()}/dash`);
		} else {
			navigation('/login');
		}
	}, [organisation]);

	return <></>;
}
